(function () {
    'use strict';

    angular.module('swif.interventions')
        .component('listGroupItemIntervention', {
            templateUrl: 'partials/openstc/list-group-item-intervention.html',
            bindings: {
                intervention: '<'
            }
        })
        .directive('panelIntervention', panelIntervention);


    function panelIntervention(swif, swifOpenbaseSiteService) {
        'ngInject';
        var params = {};
        params.fields = ['id', 'swif_id', 'name', 'state', 'cancel_reason', 'date_deadline', 'description', 'site1', 'site_details', 'intervention_assignement_id', 'service_id', 'equipment_id', 'create_uid', 'create_date', 'total_hours', 'ask_id'];
        var linked = function (scope) {
            swif.attachment.addAttachments(scope.item);

            // Display complete site address if patrimoine module is installed
            if (swif.settings.app.modules.openstc_patrimoine && scope.item.site1) {
                swifOpenbaseSiteService.getSiteAddressById(scope.item.site1[0]).then(site => {
                    swifOpenbaseSiteService.getSiteAddressFields().map(field => {
                        scope.item[field] = site[field];
                    });
                });
            }
        };
        var directive = swif.panel.create_directive('intervention', params, linked);
        directive.templateUrl = 'partials/openstc/panel-intervention.html';
        return directive;
    }

})();
